import type { ReactNode } from 'react';
import { AuthProvider } from './auth';
import { EventsProvider } from './events';
import { HealthProvider } from './health';
import { ThemeProvider } from './theme';
import { ToastProvider } from './toast';

/**
 * Provider order matters in one place only: events read the API key straight
 * from localStorage rather than from auth state, so a sign-out is picked up by
 * the storage poll and tears the stream down without a reload.
 */
export function AppProviders({ children }: { children: ReactNode }): JSX.Element {
  return (
    <ThemeProvider>
      <ToastProvider>
        <HealthProvider>
          <AuthProvider>
            <EventsProvider>{children}</EventsProvider>
          </AuthProvider>
        </HealthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export { useAuth } from './auth';
export { EVENT_NAMES, useEvents, useLiveEvent } from './events';
export { useHealth } from './health';
export { useTheme } from './theme';
export { useToast } from './toast';
export { useAction, useResource } from './useResource';
export type { Resource, UseResourceOptions } from './useResource';